import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import clsx from 'clsx';
const colors = {
    base: 'text-blue-gray-100',
    error: 'text-red-100',
    inactive: 'text-inactive',
    info: 'text-turquoise-blue-100',
    primary: 'text-navy-100',
    secondary: 'text-orange-100',
    text: 'text-gray-600',
    white: 'text-white',
    /* eslint-disable sort-keys-fix/sort-keys-fix */
    current: 'text-current',
    none: '',
    /* eslint-enable sort-keys-fix/sort-keys-fix */
};
const sizes = {
    /* eslint-disable sort-keys-fix/sort-keys-fix */
    xxl: 'text-[60px]',
    xl: 'text-[48px]',
    lg: 'text-[32px]',
    md: 'text-[24px]',
    sm: 'text-[20px]',
    xs: 'text-[12px]',
    current: '1em',
    none: '',
    /* eslint-enable sort-keys-fix/sort-keys-fix */
};
/**
 * SvgIcon の元になるコンポーネント
 * NOTE: デザインシステムのルールに基づいて値を設定をしています
 * WARNING: 設定値の変更, 追加をする場合は、デザインデータの更新必須（none 等は例外）
 * @param props
 * @returns
 */
export const SvgIconBase = (props) => {
    const { children, className = '', color, size } = props;
    const svgStyle = css `
    svg {
      vertical-align: text-top;
    }
  `;
    return (_jsx("span", Object.assign({ className: clsx('inline-flex flex-shrink-0', color && colors[color], size && sizes[size], className), css: svgStyle }, { children: children })));
};
export const svgIconColors = colors;
export const svgIconSizes = sizes;
